import { render, staticRenderFns } from "./tree2.vue?vue&type=template&id=c15510f8"
import script from "./tree2.vue?vue&type=script&lang=js"
export * from "./tree2.vue?vue&type=script&lang=js"
import style0 from "./tree2.vue?vue&type=style&index=0&id=c15510f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports